import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { Vehicle } from '../../../models/route-replay-response.model';
import { IMG_CONSTANTS } from 'src/app/route-replay/constants/img-constants';

@Component({
  selector: 'app-vehicles-list',
  templateUrl: './vehicles-list.component.html',
  styleUrl: './vehicles-list.component.scss'
})
export class VehiclesListComponent implements OnInit, OnChanges {
  @Input() vehicles: Vehicle[] = [];
  @Output() vehicleSelectionChange = new EventEmitter<Vehicle[]>();

  isExpanded: boolean = true;
  selectedVehicles: Vehicle[] = [];
  readonly imgConstants = IMG_CONSTANTS;

  ngOnInit(): void {
    // Don't emit immediately, wait for data
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['vehicles'] && !changes['vehicles'].firstChange) {
      // Auto-select only the first vehicle with valid milestone data
      this.autoSelectFirstVehicle();
    }
  }

  private autoSelectFirstVehicle(): void {
    // Select the first vehicle if it exists
    if (this.vehicles.length > 0) {
      const firstVehicle = this.vehicles[0];
      firstVehicle.selected = true;
      this.selectedVehicles = [firstVehicle];
      this.vehicleSelectionChange.emit(this.selectedVehicles);
    } else {
      this.selectedVehicles = [];
    }
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  selectAll(): void {
    // Select ALL vehicles (not just those with valid data)
    this.vehicles.forEach(vehicle => {
      vehicle.selected = true;
    });
    
    this.selectedVehicles = this.vehicles.filter(v => v.selected);
    this.vehicleSelectionChange.emit(this.selectedVehicles);
  }

  deselectAll(): void {
    this.vehicles.forEach(vehicle => {
      vehicle.selected = false;
    });
    
    this.selectedVehicles = [];
    this.vehicleSelectionChange.emit(this.selectedVehicles);
  }

  isAllSelected(): boolean {
    // Check if all vehicles are selected (not just those with valid data)
    return this.vehicles.length > 0 && this.vehicles.every(v => v.selected);
  }

  toggleSelectAll(): void {
    if (this.isAllSelected()) {
      this.deselectAll();
    } else {
      this.selectAll();
    }
  }

  toggleVehicleSelection(vehicle: Vehicle): void {
    vehicle.selected = !vehicle.selected;
    
    if (vehicle.selected) {
      this.selectedVehicles.push(vehicle);
    } else {
      const index = this.selectedVehicles.findIndex(v => v.etsVehicle.guId === vehicle.etsVehicle.guId);
      if (index > -1) {
        this.selectedVehicles.splice(index, 1);
      }
    }
    
    this.vehicleSelectionChange.emit(this.selectedVehicles);
  }

  getSelectedCount(): number {
    return this.selectedVehicles.length;
  }

  getTotalCount(): number {
    return this.vehicles.length;
  }
}
